<script setup lang="ts">
import { Header } from '@/components/ui';
import { Footer } from '@/components/ui';
import { convertUrl } from '@/utils/convertUrl';

const MY_NUMBER_PROCESSING = '個人番号（マイナンバー）について見えないように加工（マスキング）されていること';
const D_CARD_CASHING =
  'ｄカードのキャッシングをご利用中のお客さまへの注意事項は<a class="arrow_icon arrow_icon02" href="/apply/#anc_02">こちら</a>';
const REQUISITION =
  '徴求月が1～6月の場合：証明する年が前々年分以後のもの<br />徴求月が7～12月の場合：証明する年が前年分以後のもの';
</script>

<template>
  <Header />
  <div class="isp hbg_bg"></div>

  <nav class="breadcrumb">
    <div class="breadcrumb_inr">
      <ol class="breadcrumb_list" itemscope itemtype="https://schema.org/BreadcrumbList">
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a itemprop="item" href="/"><span itemprop="name">トップ</span></a
          ><meta itemprop="position" content="1" />
        </li>
        <span>&nbsp;</span>
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a itemprop="item" href="/apply/"><span itemprop="name">お申込みについて</span></a
          ><meta itemprop="position" content="2" />
        </li>
        <span>&nbsp;</span>
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <span itemprop="name">収入証明書類について</span><meta itemprop="position" content="3" />
        </li>
      </ol>
    </div>
  </nav>
  <!-- /.breadcrumb -->

  <main>
    <section class="section01">
      <div class="section_inr01">
        <h1 class="title_lv1">収入証明書類について</h1>
        <p class="textType01">
          お申込み内容やご利用状況によって、収入を証明する書類をご提出いただく場合がございます。<br />スマートフォンで撮影、または事前に撮影した画像のアップロードでご提出いただけます。
        </p>
      </div>
    </section>
    <!-- /.section01 -->

    <section class="section02 bgRed">
      <div class="section_inr01">
        <h2 class="title_lv2"><span class="ask">収入証明の提出が</span><span class="ask">必要な場合の条件</span></h2>
        <p class="textType01">貸金業法により、以下のいずれかに該当する場合には、収入証明書類のご提出が必要です。</p>
        <div class="box bgWhite borderR baseMt01">
          <ol class="listType06 mt0">
            <li class="mun_icon">
              dスマホローン（ご契約極度額または、借入残高の高い方）※1とdカードのキャッシングサービス（枠または、借入残高の高い方）の合計額が、50万円を超える場合
            </li>
            <li class="mun_icon icon_02">
              dスマホローン（ご契約極度額または、借入残高の高い方）※1とdカードのキャッシングサービス（枠または、借入残高の高い方）および他社借入額の総合計が100万円を超える場合
            </li>
            <li class="mun_icon icon_03">すでにご提出いただいた収入証明書類の発行日から、３年以上が経過した場合</li>
            <li class="mun_icon icon_04">年収や勤務先等の情報を変更した場合</li>
          </ol>
        </div>
        <ol class="listType02">
          <li>お申込みの際は、dスマホローンの借入希望額</li>
        </ol>
        <ul class="listType01">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <li v-html="D_CARD_CASHING"></li>
        </ul>

        <!--<div class="box bgWhite borderR baseMt01">
					<h4 class="title_lv4">収入証明書類に記載されている氏名または住所と、現氏名または現住所が異なる場合</h4>
					<p class="textType01">下記の補助書類をご提出いただくことで、お申込みができます。その場合、ご契約いただくお客さま名義のものに限ります。</p>
					<ul class="listType03">
						<li>納税証明書（最新年度のもの）</li>
						<li>公共料金領収書（発行日から3か月以内のもの）</li>
						<li>戸籍謄（抄）本（発行日から3か月以内のもの）</li>
						<li>住民票（発行日から3か月以内のもの）</li>
						<li>住民基本台帳カード</li>
						<li>年金手帳<span class="notes_icon">※1</span></li>
						<li>健康保険証<span class="notes_icon">※1</span></li>
					</ul>
					<ol class="listType02">
						<li>住所欄が手書きの場合は、現住所の確認書類としてはご利用いただけません。</li>
					</ol>
				</div>-->
      </div>
    </section>
    <!-- /.section02 -->

    <section class="section03">
      <div class="section_inr01">
        <h2 class="title_lv2">ご提出いただく収入証明書類</h2>
        <p class="textType01">ご提出の際は、直近に発行されている以下いずれかの書類をご用意ください。</p>
        <ul class="inLink_list baseMt04">
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo01">源泉徴収票（推奨）</a></li>
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo02">支払調書</a></li>
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo03">年金通知書</a></li>
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo04">給与の支払明細書</a></li>
          <li class="inLink_listItem">
            <a class="arrow_icon inLink" href="#syoumeisyo05">確定申告書・青色申告決算書・収支内訳書</a>
          </li>
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo06">納税通知書・納税証明書</a></li>
          <li class="inLink_listItem">
            <a class="arrow_icon inLink" href="#syoumeisyo07">所得証明書（課税証明書）</a>
          </li>
          <li class="inLink_listItem"><a class="arrow_icon inLink" href="#syoumeisyo08">年金証書</a></li>
        </ul>
      </div>

      <section id="syoumeisyo01" class="bgBule">
        <div class="section_inr01">
          <h3 class="title_lv3">源泉徴収票</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/gensen_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">支払金額が記載されていること</li>
                <li class="textType01">現在勤務先の名称が記載されていること</li>
                <li class="textType01" v-html="MY_NUMBER_PROCESSING"></li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>徴求月が1～2月の場合：証明する年が前々年分以後のもの</li>
                <li>徴求月が3～12月の場合：証明する年が前年分以後のもの</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo01-->

      <section id="syoumeisyo02">
        <div class="section_inr01">
          <h3 class="title_lv3">支払調書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/shiharai_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">支払金額が記載されていること</li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>徴求月が1～2月の場合：証明する年が前々年分以後のもの</li>
                <li>徴求月が3～12月の場合：証明する年が前年分以後のもの</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo02-->

      <section id="syoumeisyo03" class="bgBule">
        <div class="section_inr01">
          <h3 class="title_lv3">年金通知書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/nenkintuuti_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">支払年月・年金額が記載されていること</li>
                <li class="textType01">基礎年金番号について見えないように加工（マスキング）されていること</li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>徴求月が1～6月の場合：<u>前年分以後のもの</u></li>
                <li>徴求月が7～12月の場合：<u>当年分のもの</u></li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo03-->

      <section id="syoumeisyo04">
        <div class="section_inr01">
          <h3 class="title_lv3">給与の支払明細書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/kyuuyo_02.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">直近年月のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">現在勤務先の名称が記載されていること</li>
                <li class="textType01">支給総額が記載されていること</li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>連続した直近2か月分</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo04-->

      <section id="syoumeisyo05" class="bgBule">
        <div class="section_inr01">
          <h3 class="title_lv3">確定申告書・青色申告決算書・収支内訳書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/kakutei_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">
                  個人番号（マイナンバー）について見えないように加工（マスキング）されていること
                </li>
                <li class="textType01">収入金額と所得金額が記載されていること</li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>徴求月が1～3月の場合：確定申告日が前年以後のもの</li>
                <li>徴求月が4～12月の場合：確定申告日が当年のもの</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo05-->

      <section id="syoumeisyo06">
        <div class="section_inr01">
          <h3 class="title_lv3">納税通知書・納税証明書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/nouzei_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">所得金額・収入金額が記載されていること</li>
                <li class="textType01">発行日・発行元が記載されていること</li>
              </ul>
              <ul class="listType01 baseMt03">
                <li>徴求月が1～6月の場合：証明する年が前々年分以後のもの</li>
                <li>徴求月が7～12月の場合：証明する年が前年分以後のもの</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo06-->

      <section id="syoumeisyo07" class="bgBule">
        <div class="section_inr01">
          <h3 class="title_lv3">所得証明書（課税証明書）</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/syotoku_01.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <ul class="listType03 _num liMt10">
                <li class="textType01">最新年度のものであること※1</li>
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">所得金額・収入金額が記載されていること※2</li>
                <li class="textType01">発行日・発行元が記載されていること</li>
              </ul>
              <ol class="listType02 baseMt03">
                <li v-html="REQUISITION"></li>
                <li>給与所得や事業所得金額など内訳の記載のあるもの</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo07-->

      <section id="syoumeisyo08">
        <div class="section_inr01">
          <h3 class="title_lv3">年金証書</h3>
          <div class="certificate_flex">
            <div class="certificate_flex_img">
              <img src="/img/nenkin_01_260325.png" alt="" class="modal_img_open" />
            </div>
            <div class="certificate_flex_text">
              <p class="textType01">年金通知書が発行済みの場合は年金通知書をご提出ください</p>
              <ul class="listType03 _num liMt10">
                <li class="textType01">ご本人さまのフルネームが記載されていること</li>
                <li class="textType01">支払開始年月・年金額が記載されていること</li>
                <li class="textType01">基礎年金番号について見えないように加工（マスキング）されていること</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <!-- /#syoumeisyo08-->

      <div class="section_inr01">
        <div class="box borderType02 borderR">
          <div class="tAc">
            <img src="/img/img_31.svg" alt="注意" width="55" height="48" />
          </div>
          <div class="baseMt02">
            <p class="textType01">
              ご提出いただいた収入証明書類が不鮮明で記載内容の読み取りが困難な場合など、再提出をお願いすることがございます。<br />書類に本籍地や個人番号（マイナンバー）など第三者に取得制限がある情報や機微情報の記載がある場合は、該当部分を隠すなど写らない状態にしてご提出ください。<br />
              収入証明書類をご提出いただいた場合でも、当社での審査や他社でのご利用状況等により、お客さまのご希望に添えない場合がございます。あらかじめご了承ください。
            </p>
            <p class="textType01">
              <a class="arrow_icon arrow_icon02" href="/faq/apply/001/">マスキングについて詳しくはこちら </a>
            </p>
          </div>
        </div>
      </div>
      <!-- /.section_inr01 -->
    </section>
    <!-- /.section03 -->

    <section class="bgBule">
      <div class="section_inr02">
        <div class="relInfo">
          <h2 class="relInfo_title">関連情報：お申込みをする</h2>
          <div class="relInfo_cont">
            <p class="relInfo_lead">
              <a href="/apply/"><span class="arrow_icon">お申込みについて</span></a>
            </p>
            <ul class="relInfo_list">
              <li>
                <a href="/apply/identification/"><span class="arrow_icon">本人確認方法について</span></a>
              </li>
              <li><span class="relInfo_current">収入証明書類について</span></li>
              <li>
                <a href="/apply/banklist/"><span class="arrow_icon">ご利用可能な金融機関と振込実施時間</span></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /.relInfo -->
      </div>
    </section>
    <!-- /.bgBule -->
  </main>
  <!-- /.main -->

  <section class="section02">
    <h2 class="title_lv2">よくあるご質問</h2>
    <ul class="faq lr_noBorder">
      <li class="faq_item">
        <input type="checkbox" id="faq_01" class="acc_head" />
        <label for="faq_01" class="faq_head acc_icon">
          本人確認書類 または 収入証明書類へのマスキングはどのように行えばよいですか？
        </label>
        <div class="faq_body acc_body">
          <div class="faq_text">
            <p>
              アップロードいただく必要書類の画像に、本籍地や個人番号（マイナンバー）など第三者に取得制限がある情報や機微情報の記載がある場合、該当箇所に付箋などでマスキングが必要です。
            </p>
            <p class="textType01">
              <a class="arrow_icon arrow_icon02" href="/faq/apply/001/">マスキングについて詳しく見る　</a>
            </p>
          </div>
        </div>
      </li>
    </ul>
    <div class="section02 box04">
      <p class="btnType01"><a href="/faq/">よくあるご質問をもっと見る</a></p>
    </div>
  </section>
  <!-- /.section02 -->

  <section class="modal_img">
    <div class="modal_img_inner">
      <button class="modal_close" aria-label="閉じる"></button>
      <img src="/img/gensen_01.png" alt="" />
    </div>
  </section>
  <div class="modal_bg"></div>

  <section class="section02">
    <!--#include virtual="/focus/ssi/cv_area.html" -->
    <ul class="cv_card cv_btnArea">
      <li class="cv_card_item">
        <h2 class="title_lv2">新規お申込み</h2>
        <div class="cv_card_text_area">
          <p class="cv_card_text pctAl sptAc">
            <span class="ask"><span class="emphasis">お申込み</span>から<span class="emphasis">ご契約</span>まで</span
            ><span class="ask"><span class="emphasis">スマホ<span>で</span>完結！</span></span>
          </p>
        </div>
        <div class="cv_card_btn01">
          <p class="top_btnItem btnType02 btn_icon btn_icon01 cv_card_btn fwb">
            <a
              :href="`${convertUrl()}common/login/cushionWithUniversalLinkActivation?prompt=relogin&transitionSourceId=basic`"
              >今すぐお申込み<br /><span>（dアカウントでログイン）</span></a
            >
          </p>
          <ul class="listType01 tAl mt10">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <li v-html="D_CARD_CASHING"></li>
          </ul>
        </div>
      </li>
      <li class="cv_card_item">
        <h2 class="title_lv2">簡易シミュレーション</h2>
        <div class="cv_card_btn02">
          <p class="top_btnItem btnType03 btn_icon btn_icon04 cv_card_btn fwb">
            <a href="/apply/1second/"><span>お借入可能？優遇金利は何％？</span>簡単1秒診断</a>
          </p>
        </div>
        <div class="cv_card_btn02 mt10">
          <p class="top_btnItem btnType03 btn_icon btn_icon02 cv_card_btn fwb">
            <a href="/borrow/simulation/"
              ><span>毎月のご返済額はいくらぐらい？</span
              ><span class="fs18"><span class="ask">ご返済</span><span class="ask">シミュレーション</span></span></a
            >
          </p>
        </div>
      </li>
    </ul>
  </section>
  <!-- /.section02 -->
  <Footer />
</template>
